import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SHOW_SUMMER_PROMO } from '../constants';
import SummerOffer from '../components/SummerOffer';

const COURSES = [
  {
    id: 'python',
    icon: <img src="/python.png" alt="Python" style={{ height: 48 }} />,
    title: 'Python + AI Course',
    desc: 'Learn Python programming from absolute scratch, build real programs, and get an introduction to AI tools.',
    highlights: ['No prior experience needed', 'Logic building & problem solving', 'Intro to AI & automation', 'Build 5+ real projects'],
    duration: '6-8 Weeks',
    level: 'Beginner',
    color1: '#1B3A6B',
    color2: '#2A5298',
  },
  {
    id: 'webdev',
    icon: '🌐',
    title: 'Web Development Course',
    desc: 'Build beautiful, responsive websites from scratch using HTML, CSS, and JavaScript.',
    highlights: ['HTML5, CSS3 & JavaScript', 'Responsive & mobile design', 'Build a personal portfolio', 'Interactive web projects'],
    duration: '6-8 Weeks',
    level: 'Beginner',
    color1: '#C41E3A',
    color2: '#e84363',
  },
  {
    id: 'msoffice',
    icon: '💼',
    title: 'MS Office & AI Tools',
    desc: 'From switching on a computer to building professional documents, spreadsheets, and presentations — with AI tools.',
    highlights: ['Word, Excel & PowerPoint', 'Google Docs & Sheets', 'AI tools: ChatGPT & Canva', 'Job-ready skills from day one'],
    duration: '6-8 Weeks',
    level: 'Beginner',
    color1: '#1a5a2e',
    color2: '#16a34a',
  },
];

export default function CoursesPage() {
  const navigate = useNavigate();

  return (
    <div style={{ paddingTop: 64 }}>

      <div style={{ background: 'var(--cream)', padding: '60px 24px 48px', textAlign: 'center' }}>
        <div className="badge">Our Courses</div>
        <h1 className="section-title" style={{ textAlign: 'center' }}>Our Courses</h1>
        <p className="section-sub" style={{ margin: '0 auto', textAlign: 'center' }}>
          Three carefully designed, beginner-friendly courses to kickstart your tech journey.
        </p>
      </div>

      {SHOW_SUMMER_PROMO && <SummerOffer />}

      <section className="section">
        <div className="container">
          <div className="grid-3" style={{ gap: 32 }}>
            {COURSES.map(({ id, icon, title, desc, highlights, duration, level, color1, color2 }) => (
              <div key={id} style={{
                background: `linear-gradient(135deg, ${color1}, ${color2})`,
                borderRadius: 28, padding: 44, color: '#fff',
                position: 'relative', overflow: 'hidden',
                display: 'flex', flexDirection: 'column',
              }}>
                <div style={{ position: 'absolute', top: -28, right: -28, width: 120, height: 120, background: 'rgba(240,180,41,0.12)', borderRadius: '50%' }} />
                <div style={{ fontSize: 32, marginBottom: 14, fontWeight: 900 }}>{icon}</div>
                <h2 style={{ fontSize: 22, fontWeight: 900, marginBottom: 10 }}>{title}</h2>
                <div style={{ display: 'flex', gap: 10, marginBottom: 18, flexWrap: 'wrap' }}>
                  <span style={{ background: 'rgba(240,180,41,0.25)', color: '#F0B429', padding: '4px 14px', borderRadius: 50, fontSize: 13, fontWeight: 700 }}>
                    Duration: {duration}
                  </span>
                  <span style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', padding: '4px 14px', borderRadius: 50, fontSize: 13, fontWeight: 700 }}>
                    Level: {level}
                  </span>
                </div>
                <p style={{ color: 'rgba(255,255,255,0.82)', fontSize: 15, lineHeight: 1.7, marginBottom: 22 }}>{desc}</p>
                {highlights.map((h) => (
                  <div key={h} style={{ display: 'flex', gap: 8, marginBottom: 10, fontSize: 14, color: 'rgba(255,255,255,0.88)' }}>
                    <span style={{ color: '#F0B429', fontWeight: 900 }}>+</span>{h}
                  </div>
                ))}
                <div style={{ display: 'flex', gap: 12, marginTop: 'auto', paddingTop: 32, flexWrap: 'wrap' }}>
                  <button className="btn-gold" onClick={() => navigate(`/${id}`)}>
                    View Full Details →
                  </button>
                  <button className="btn-primary" onClick={() => navigate('/register')}>
                    Register for Course
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Pricing note */}
          <div style={{
            marginTop: 40, background: 'linear-gradient(135deg, #F0B429, #d9a020)',
            borderRadius: 24, padding: 40,
            display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 24,
          }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--navy)', opacity: 0.7, marginBottom: 4 }}>COMBO OFFER AVAILABLE</div>
              <h3 style={{ fontSize: 24, fontWeight: 900, color: 'var(--navy)' }}>Take Multiple Courses Together!</h3>
              <p style={{ color: 'rgba(27,58,107,0.75)', marginTop: 8, fontSize: 15 }}>
                Enroll in any combination of courses and save more. Complete your tech foundation in one go.
              </p>
              <p style={{ color: 'rgba(27,58,107,0.65)', marginTop: 6, fontSize: 14, fontStyle: 'italic' }}>
                💡 Price details are available on the Registration Page.
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <button className="btn-primary" style={{ marginTop: 14 }} onClick={() => navigate('/register')}>
                View Fees & Register →
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ background: 'var(--cream)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <div className="badge">Do Not Wait</div>
          <h2 className="section-title" style={{ textAlign: 'center' }}>Why Start Now?</h2>
          <div className="grid-3" style={{ marginTop: 36 }}>
            {[
              ['Fast Start', 'Every day you delay is a day another student gets ahead.'],
              ['Career Value', 'Internship & job applications look at skills - not just marks.'],
              ['First Class Demo', 'First class is included as demo. Fee can be paid in the first 3 classes.'],
            ].map(([title, text]) => (
              <div key={title} className="card" style={{ textAlign: 'center', padding: '28px 24px' }}>
                <div style={{ fontSize: 18, marginBottom: 12, fontWeight: 800, color: 'var(--navy)' }}>{title}</div>
                <p style={{ color: 'var(--gray)', fontSize: 15, lineHeight: 1.65 }}>{text}</p>
              </div>
            ))}
          </div>
          <button
            className="btn-primary"
            style={{ marginTop: 40, fontSize: 16, padding: '15px 36px' }}
            onClick={() => navigate('/register')}
          >
            Register for Course
          </button>
        </div>
      </section>
    </div>
  );
}